// extracted by mini-css-extract-plugin
module.exports = {"detailRateModal":"AC","rateHeaderRow":"AD","closeIcon":"AE","closeIconWrapper":"AF","rateText":"AG","rateOptionsRow":"AH"};